import { render } from "./ButtonSubmit.vue?vue&type=template&id=0b9789cc"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__